import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';

@model.urnResource('plan_analysis')
@doc.path('/plan_analyses/{?id}')
export default class PlanAnalysisModel extends MapServiceModel {
	private declare _tsFilters: {
		'import': id;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.json   declare planAnalysisStatus: StatusReference | string;
	@doc.number declare nbInsertions: number;
	@doc.number declare nbUpdates: number;
	@doc.number declare nbDuplicates: number;
	@doc.number declare nbLocked: number;
	@doc.json   declare duplicates: { number: string; category: string }[] | null;
	@doc.json   declare lockedLines: unknown[] | null;
	@doc.string declare errorMessage: string | null;
}

export type StatusReference = { reference?: string };
